// extracted by mini-css-extract-plugin
module.exports = {"tabsNav":"useScrollable_tabsNav__41kFP","left":"useScrollable_left__licjM","right":"useScrollable_right__F_v_v"};